export default "__VITE_ASSET__Bs_goJVU__"